// note: remove /jira/helpcenter and /jira/customer-service when cleaning csm_appification_standalone_navigation
const CSM_ROUTE_PREFIXES = [
	'/jira/customer-service-management',
	'/jira/helpcenter',
	'/jira/customer-service',
];

export const isCsmPath = (pathname: string): boolean =>
	CSM_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
